import { render, staticRenderFns } from "./TestPlugin.vue?vue&type=template&id=7801fca2&scoped=true"
import script from "./TestPlugin.vue?vue&type=script&lang=js"
export * from "./TestPlugin.vue?vue&type=script&lang=js"
import style0 from "./TestPlugin.vue?vue&type=style&index=0&id=7801fca2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7801fca2",
  null
  
)

export default component.exports